import {
  Typography,
  TypographyMods,
  TypographySizes,
} from '@vk-cloud-solutions/marketing-ui';

import { Accordion } from '~components/Accordion/Accordion';
import { ContentBlockWrapper } from '~containers/ArticlePage/ContentBlockWrapper/ContentBlockWrapper';

import styles from './ContentBlockFaq.module.scss';
import { ContentBlockFaqProps } from './ContentBlockFaq.types';

export function ContentBlockFaq({
  title,
  items,
  ...sectionProps
}: ContentBlockFaqProps) {
  return (
    <ContentBlockWrapper {...sectionProps}>
      <Typography
        tagName={TypographySizes.h2}
        mods={[TypographyMods.titleL]}
        className={styles.title}
      >
        {title}
      </Typography>
      <div className={styles.wrapper}>
        {items.map((item) => (
          <Accordion {...item} key={item.id} />
        ))}
      </div>
    </ContentBlockWrapper>
  );
}
